import { render, staticRenderFns } from "./searchResults.vue?vue&type=template&id=21022570&scoped=true"
import script from "./searchResults.vue?vue&type=script&lang=js"
export * from "./searchResults.vue?vue&type=script&lang=js"
import style0 from "./searchResults.vue?vue&type=style&index=0&id=21022570&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21022570",
  null
  
)

export default component.exports